import { Vector2 } from "../../../common/vector2.js";
import type { UIImage } from "../../common_ui_elements/ui_image.js";
import type { RewardFlySource } from "../../reward_fly/reward_fly_to_hud.js";
import type { IOnePlusOneReward } from "./one_plus_one_offer_screen.js";

/** A reward icon drawn in a 1+1/1+2 column, kept so a claim can fly it to the HUD. */
export interface OnePlusRewardIcon
{
  reward: IOnePlusOneReward;
  icon: UIImage;
}

/** Same targets as the chain offer: coins to the counter, hearts to hearts, the rest to the avatar. */
export function onePlusRewardFlySources( icons: readonly OnePlusRewardIcon[] ): RewardFlySource[]
{
  return icons.map( ( { reward, icon } ) =>
  {
    const pos = icon.getAbsolutePosition();
    const rect = icon.getRect();
    const is_heart = reward.type === "hearts" || reward.type === "infinite_hearts_minutes";
    return {
      target: reward.type === "coins" ? "coin" : is_heart ? "heart" : "avatar",
      img_id: reward.icon,
      center: new Vector2( pos.x + rect.getW() / 2, pos.y + rect.getH() / 2 ),
      size: rect.getW(),
      amount: reward.amount,
      copies: reward.type === "hearts" ? Math.max( 1, Math.min( 3, reward.amount ) ) : 1,
    };
  } );
}
